/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Complimentary_Account_LabelInputs */

const fr_admin_complimentary_account_label = /** @type {(inputs: Admin_Complimentary_Account_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte offert`)
};

/**

* @param {Admin_Complimentary_Account_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_complimentary_account_label = /** @type {((inputs?: Admin_Complimentary_Account_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Complimentary_Account_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_complimentary_account_label(inputs)
});